import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import Icon from 'components/generic/Icon.component';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import logger from 'utils/logger.util';

import PopupModalContainer from 'common/PopupModal';
import { addRole, clearRoleState, editRole, getRoles, removeSavedRolesIds } from 'onboarding/roles/actions';
import RolesScreenContainer from 'onboarding/roles/RolesScreen';
import { getCategories } from 'onboarding/services/actions';

import CN from './RolesLayout.module.scss';

const L = logger('RolesLayout');

class RolesLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: '',
      savingInProgress: false,
      editedRolesIds: [],
      addRoleExpanded: false,
      settingsSavedRolesTimerIds: [],
    };
  }

  UNSAFE_componentWillMount() {
    const { getCategories, getRoles, getStylists } = this.props;

    const salonId = fromPropsToMatchedSalonId(this.props);

    L.unignore('UNSAFE_componentWillMount()', 'getStylists:', getStylists(salonId));
    L.unignore('UNSAFE_componentWillMount()', 'getCategories:', getCategories(salonId));
    L.unignore('UNSAFE_componentWillMount()', 'getRoles:', getRoles(salonId));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.roleIsSaved && nextProps.roleIsSaved) {
      if (this.state.addRoleExpanded && this.state.savingInProgress) {
        this.setState({ addRoleExpanded: false, savingInProgress: false });
      }
      this.props.clearRoleState();
    }

    // Handle the roles that have been marked as saved with the last request
    const differenceRoles = nextProps.settingsSavedRolesIDs.filter((categorySaved) => categorySaved.isNew).map((categorySaved) => categorySaved.id);

    const settingsSavedRolesTimerIds = this.state.settingsSavedRolesTimerIds.slice(0);

    if (differenceRoles.length) {
      const timerId = window.setTimeout(() => {
        this.props.removeSavedRolesIds(differenceRoles);
        differenceRoles.forEach((id) => {
          settingsSavedRolesTimerIds.splice(id, 1);
        });
      }, 2000);

      differenceRoles.forEach((id) => {
        window.clearTimeout(settingsSavedRolesTimerIds[id]);
        settingsSavedRolesTimerIds[id] = timerId;
      });
    }
    this.setState({
      settingsSavedRolesTimerIds,
      errorMessage: nextProps.requestErrorMessage,
    });
  }

  onEditRole = (roleName, roleId) => {
    const ind = this.state.editedRolesIds.indexOf(roleId);
    if (ind === -1) {
      const editedRolesIds = this.state.editedRolesIds.slice(0);
      editedRolesIds.push(roleId);
      this.setState({ editedRolesIds });
    } else {
      const editedRolesIds = this.state.editedRolesIds.slice(0);
      editedRolesIds.splice(ind, 1);
      this.setState({ editedRolesIds });
    }
  };

  hideError = () => {
    this.setState({ errorMessage: '' });
    this.props.clearRoleState();
  };

  render() {
    const { addRoleExpanded, errorMessage, editedRolesIds, savingInProgress } = this.state;
    const { isDarkMode, addRole, getCategories, currentSalon, editRole, t } = this.props;

    const salonId = fromPropsToMatchedSalonId(this.props);

    return (
      <div
        className={cn({
          'services online-booking-layout': true,
          [CN.component]: true,
          [CN.dark]: isDarkMode,
        })}
      >
        <div className={CN.container}>
          {fromAnyToBool(errorMessage) && <PopupModalContainer popupTitle={t('common.error')} popupMessage={errorMessage} buttonText={t('common.buttons.okay')} buttonCallback={this.hideError} />}

          <div className={CN.flex}>
            <div className={CN.pageTitle}>
              <div className={CN.pageIcon}>
                <Icon variant="briefcase" width="xl" />
              </div>
              {t('staffAndBusiness.jobTitles.title')}
            </div>

            <div className={CN.subTitle}>{t('staffAndBusiness.jobTitles.description')}</div>
          </div>

          <RolesScreenContainer
            salon={currentSalon}
            editedRolesIds={editedRolesIds}
            hideAddBtn={addRoleExpanded}
            onDotMenuEditClick={this.onEditRole}
            showSaved
            onAddRoleClick={() => void this.setState({ addRoleExpanded: !addRoleExpanded })}
            addRoleBtn={(roleName, copyFromId) => {
              this.setState({ savingInProgress: true });
              addRole(roleName, salonId, copyFromId);
            }}
            editRoleSaveBtn={(role) => {
              this.onEditRole(role.name, role.id);
              editRole(role.name, role.id, salonId);
            }}
            addBtnDisabled={savingInProgress}
            errorMessage={errorMessage}
            getCategories={getCategories}
          />
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => ({
  requestErrorMessage: state.onboarding.roles.errorMessage,
  roleIsSaved: state.onboarding.roles.isSaved,
  settingsSavedRolesIDs: state.onboarding.roles.settingsSavedRolesIDs,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getStylists: fetchStylistsBySalon,
      getCategories,
      getRoles,
      clearRoleState,
      addRole,
      editRole,
      removeSavedRolesIds,
    },
    dispatch,
  );

const RolesLayoutHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withTheme()(RolesLayout)));

export default RolesLayoutHoc;
